import { DedicatedServerNetworkMetric } from '../../../../api/bareMetalTypes'

const metricFields = ['bwrate_in', 'bwrate_out', 'traffic_in', 'traffic_out'] as const
type MetricField = typeof metricFields[number]
type NetworkSample = { time: string } & Record<MetricField, number>

// The API sends one row per sensor; the chart needs one sample per timestamp.
export function groupNetworkMetrics(stats: DedicatedServerNetworkMetric[]): NetworkSample[] {
  const samples = new Map<string, NetworkSample>()
  for (const stat of stats) {
    if (!metricFields.includes(stat.sensor_tag as MetricField)) continue
    if (!Number.isFinite(stat.sensor_value)) continue
    const sample = samples.get(stat.time) || {
      time: stat.time, bwrate_in: 0, bwrate_out: 0, traffic_in: 0, traffic_out: 0,
    }
    sample[stat.sensor_tag as MetricField] = stat.sensor_value
    samples.set(stat.time, sample)
  }
  return [...samples.values()].sort((a, b) => Date.parse(a.time) - Date.parse(b.time))
}

function roundToHalf(value: number): number {
  const roundedValue = Math.round(value);
  return roundedValue;
}

export function calculateScales(data: NetworkSample[] = []): any {
  const packetsScale: number[] = [];
  const bytesScale: number[] = [];

  if (data.length === 0) {
    return [packetsScale, bytesScale];
  }

  // Находим максимальные значения packets_in, packets_out, bytes_in и bytes_out
  const maxPacketsIn = Math.max(...data.map((measure) => measure.bwrate_in));
  const maxPacketsOut = Math.max(...data.map((measure) => measure.bwrate_out));
  const maxBytesIn = Math.max(...data.map((measure) => measure.traffic_in));
  const maxBytesOut = Math.max(...data.map((measure) => measure.traffic_out));

  // Определяем количество точек (в данном случае, 11)
  const numPoints = 8;

  // Вычисляем шаг для шкалы, используя максимальные значения из обоих полей
  const packetsStep = Math.max(maxPacketsIn, maxPacketsOut) / (numPoints - 1);
  const bytesStep = Math.max(maxBytesIn, maxBytesOut) / (numPoints - 1);

  // Создаем шкалы
  for (let i = 0; i < numPoints; i++) {
    const packetsValue = i * packetsStep;
    const bytesValue = i * bytesStep;

    // Округляем до половины с учетом знака
    const roundedPackets = roundToHalf(packetsValue);
    const roundedBytes = roundToHalf(bytesValue);
    const sizes = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y']
    const sizes1 = ['', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    //@ts-ignore
    packetsScale.push(transformValues(packetsValue, 2,sizes));
    //@ts-ignore
    bytesScale.push(transformValues(roundedBytes, 2 ,sizes1));
  }

  return [packetsScale?.reverse(), bytesScale?.reverse()];
}



function transformValues(value:any, decimals:any, sizes:any) {
  const dm = decimals || 2;
  if (value <= 1) {
    return value.toFixed(dm) + ' ' + sizes[0];
  }
  const k = 1000;
  const i = Math.floor(Math.log(value) / Math.log(k));
  return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function createPercentageArray(length:any) {
  if (length < 1) {
    return [];
  }

  if (length === 1) return [0];
  const step = 100 / (length - 1);
  const result = [];

  for (let i = 0; i < length; i++) {
    result.push(i * step);
  }

  return result;
}

export function createPercentageArrays(data: NetworkSample[], fieldName: MetricField): [number, number, string, string][] {
  const step = Math.floor(data.length / 100);
  const maxPacketsIn = Math.max(...data.map((measure) => measure.bwrate_in));
  const maxPacketsOut = Math.max(...data.map((measure) => measure.bwrate_out));
  const maxBytesIn = Math.max(...data.map((measure) => measure.traffic_in));
  const maxBytesOut = Math.max(...data.map((measure) => measure.traffic_out));


  const packetsStep = Math.max(maxPacketsIn, maxPacketsOut);
  const bytesStep = Math.max(maxBytesIn, maxBytesOut);

  const isBytes = fieldName === 'traffic_in' || fieldName === 'traffic_out'
  const maximum = isBytes ? bytesStep : packetsStep;
  const percentValues = createPercentageArray(data.length);
  const resultArrays: [number, number, string, string][] = data.map((measure, index) => {
    const percentValue = maximum <= 0 ? 0 : (measure[fieldName] / maximum) * 100;

    return [percentValues[index], percentValue, measure.time, measure[fieldName].toFixed(2)];
  });
  // console.log('resultArrays',resultArrays);
  return resultArrays;
}

